import React from 'react'
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

const GcsEyes = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <FormControl fullWidth>
      <InputLabel>GCS (Eye Opening)</InputLabel>
      <Select value={value} onChange={onChange} label="GCS (Eye Opening)">
        <MenuItem value="4">4 - Spontaneously</MenuItem>
        <MenuItem value="3">3 - To Speech</MenuItem>
        <MenuItem value="2">2 - To Pain</MenuItem>
        <MenuItem value="1">1 - No Response</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

const GcsVerbal = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <FormControl fullWidth>
      <InputLabel>GCS (Verbal Response)</InputLabel>
      <Select value={value} onChange={onChange} label="GCS (Verbal Response)">
        <MenuItem value="5">5 - Orientated</MenuItem>
        <MenuItem value="4">4 - Confused</MenuItem>
        <MenuItem value="3">3 - Inappropriate Words</MenuItem>
        <MenuItem value="2">2 - Incomprehensible Sounds</MenuItem>
        <MenuItem value="1">1 - No Response</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

const GcsMotor = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <FormControl fullWidth>
      <InputLabel>GCS (Motor Response)</InputLabel>
      <Select value={value} onChange={onChange} label="GCS (Motor Response)">
        <MenuItem value="6">6 - Obeys Commands</MenuItem>
        <MenuItem value="5">5 - Moves to Localised Pain</MenuItem>
        <MenuItem value="4">4 - Flexes away from Pain</MenuItem>
        <MenuItem value="3">3 - Abnormal Flexion</MenuItem>
        <MenuItem value="2">2 - Abnormal Extension</MenuItem>
        <MenuItem value="1">1 - No Response</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export { GcsEyes, GcsVerbal, GcsMotor }
